import Layout from '../../config/Layout';
import Colors from '../../config/Colors';

const borderStyle = (invalid = false) => {
    return {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: invalid ? Colors.danger : Colors.border,
        borderRadius: 5
    };
};

export const inputComponentStyle = (invalid = false, disabled = false) => {
    return {
        minHeight: 38,
        maxHeight: 38,
        height: 38,
        paddingLeft: Layout.gutterSmall,
        paddingRight: Layout.gutterSmall,
        paddingTop: 0,
        paddingBottom: 0,
        fontSize: 14,
        backgroundColor: disabled ? Colors.grey : Colors.white,
        ...borderStyle(invalid)
    };
};

export const selectComponentStyle = (invalid = false) => {
    return {
        minHeight: 40,
        maxHeight: 40,
        height: 40,
        paddingLeft: Layout.gutterSmall,
        paddingRight: Layout.gutterSmall,
        paddingTop: 0,
        paddingBottom: 0,
        fontSize: 14,
        ...borderStyle(invalid)
    };
};

export default {
    container: {
        flex: 10,
        display: 'flex',
        fontFamily: 'NunitoSans-Regular'
    },
    formContainer: {
        display: 'flex',
        flex: 2
    },
    imageContainer: {
        display: 'flex',
        flex: 3
    },
    image: {
        height: 145,
        marginLeft: 21,
        marginTop: 21,
        ...borderStyle(false),
        backgroundColor: Colors.grey,
        padding: Layout.gutter
    },
    imageButton: {
        minHeight: 38,
        marginLeft: 21,
        backgroundColor: Colors.secondary
    },
    imageButtonText: {
        fontSize: 14
    },
    inputFileButton: {
        width: 205,
        height: 38,
        marginTop: 15,
        marginLeft: 21,
        backgroundColor: Colors.secondary,
        borderRadius: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
    },
    inputContainer: {
        flex: 1,
        minHeight: 80,
        display: 'flex'
    },
    label: {
        fontSize: '1.6rem'
    },
    textArea: {
        resize: 'none'
    },

    errorMessage: {
        fontSize: 12,
        color: Colors.danger
    },

    twoColumns: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },

    firstSon: {
        marginRight: Layout.gutterSmall
    },
    lastSon: {
        marginLeft: Layout.gutterSmall
    }
};
